<template>
  <div
    class="aside-container"
    height="100%"
  >
    <div
      id="search-box"
      class="search-box"
    >
      <el-input
        v-model="departmentName"
        placeholder="請輸入組別名稱"
        @keyup.enter.native="search"
      >
        <i
          slot="prefix"
          class="el-input__icon el-icon-search"
        />
      </el-input>
      <el-button @click="search">
        搜尋
      </el-button>
      <!-- <i @click="toggleAsideWidth" v-show="isExpanded" class="el-icon-caret-bottom"></i>
      <i @click="toggleAsideWidth" v-show="!isExpanded" class="el-icon-caret-right"></i> -->
      <el-button
        :class="{'exdbut':!isExpanded}"
        @click="toggleAsideWidth"
      >
        {{ isExpanded ? '收起' : '展開' }}
      </el-button>
    </div>
    <!-- <div class="btn-classify">
      <span :class="{active:isActive ===1 }" @click="setActive(1)">有效組別</span>
      <span :class="{active:isActive ===2}" @click="setActive(2)">全部組別</span>
    </div>-->
    <div
      ref="treeList"
      class="tree-list"
      :style="{height:treeHeight,overflowY:'auto'}"
    >
      <!-- <el-scrollbar class="filter-tree" view-style = " height:100%"> -->
      <!-- :default-expanded-keys="defaultExpandedKeys" -->
      <el-tree
        ref="tree"
        v-loading="loading"
        empty-text="暫無數據"
        :expand-on-click-node="false"
        :data="treeDataList"
        node-key="departmentID"
        :default-expanded-keys="[userInfo.departmentID]"
        :props="defaultProps"
        :filter-node-method="filterNode"
        @node-click="nodeClick"
      >
        <span
          slot-scope="{ node, data }"
          class="custom-tree-node text-cut"
          :title="node.label"
        >
          <span>{{ node.label }}</span>
          <!-- HOUSEMIS-4131 優化介面可加宽並加上快捷鍵 -->
          <div
            v-show="showExpanded"
            class="aside-tree-link"
            @click="staffClick(node,data)"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <!-- <use :xlink:href="data.departmentStaffCount ? '#iconyuangongguanli1-copy' : '#iconyuangongguanli1-copy-copy'" /> -->
              <use :xlink:href="getStaffIconHref(node, data)" />
              <!-- <use :xlink:href="getDynamicIconHref(data, 'departmentStaffCount', '#iconyuangongguanli1-copy', '#iconyuangongguanli1-copy-copy', '#iconyuangongguanli2')" /> -->
            </svg>
          </div>
          <div
            v-show="showExpanded"
            class="aside-tree-link aside-link"
            @click="depClick(node,data)"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <!-- <use :xlink:href="data.childDepartmentCount ? '#iconzuzhiguanli-copy' : '#iconzuzhiguanli-copy-copy'" /> -->
              <use :xlink:href="getDepIconHref(node, data)" />
              <!-- <use :xlink:href="getDynamicIconHref(data, 'childDepartmentCount', '#iconzuzhiguanli-copy', '#iconzuzhiguanli-copy-copy', '#iconzuzhiguanli2')" /> -->
            </svg>
          </div>
        </span>
      </el-tree>
      <!-- </el-scrollbar> -->
    </div>
    <!-- HOUSEMIS-4131 優化介面可加宽並加上快捷鍵-->
    <div
      :class="['expanfold-icon',!isExpanded ? 'left_95': 'left_98']"
      @click="toggleAsideWidth"
    >
      <svg
        v-show="!isExpanded"
        class="icon"
        aria-hidden="true"
      >
        <use xlink:href="#iconzhankai1" />
      </svg>
      <svg
        v-show="isExpanded"
        class="icon"
        aria-hidden="true"
      >
        <use xlink:href="#iconshouqi" />
      </svg>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "AsideBar",
  props: {
    currentSelected: Number,
    isExpanded: Boolean,
    treeDataList: Array,
    loading: Boolean,
    asideHeight: Number
  },
  data() {
    return {
      // defaultExpandedKeys: [],
      showExpanded:true,
      isActive: 1, // 1 有效，2无效
      treeData: [],
      departmentName: "",
      defaultProps: {
        children: "childNode",
        label: "departmentName"
      },
      treeHeight: 100
    };
  },
  created() {
    if(this.$route.name == 'Coin_CoinManage' || this.$route.name == 'Coin_Record'){
      this.showExpanded = true;
    }else{
      this.showExpanded = false;
    }
    // if(!this.$route.query.depId){
    //   this.defaultExpandedKeys.push(this.userInfo.departmentID)
    // }
  },
  mounted() {},
  methods: {
    setTreeExpandedAndSelected(pathIds) {
      if (!pathIds || pathIds.length === 0) {return;}
      this.$nextTick(() => {
        // 展开所有父节点
        this.$refs.tree.setCurrentKey(pathIds[pathIds.length - 1]); // 选中最后一个节点
        this.defaultExpandedKeys = pathIds; // 展开路径上的所有节点
        pathIds.forEach(id => {
          const node = this.$refs.tree.getNode(id);
          if (node && !node.expanded) {
            node.expand();
          }
        });
      });
    },
    getDepIconHref(node, data) {
      const hasChild = Boolean(data.childDepartmentCount);
      const currentKey = this.$refs.tree.getCurrentKey();
      const isSelected = currentKey === data.departmentID;

      if (!hasChild) {
        return '#iconzuzhiguanli-copy-copy'; // 沒有子部門
      }

      if (isSelected && this.currentSelected == 1) {
        return '#iconzuzhiguanli-copy'; // 有子部門且被選中
      }

      return '#iconzuzhiguanli2'; // 有子部門但未選中
    },
    getStaffIconHref(node, data) {
      const hasStaff = Boolean(data.departmentStaffCount);
      const currentKey = this.$refs.tree.getCurrentKey();
      const isSelected = currentKey === data.departmentID;

      if (!hasStaff) {
        return '#iconyuangongguanli1-copy-copy'; // 無員工
      }

      if (isSelected && this.currentSelected == 2) {
        return '#iconyuangongguanli1-copy'; // 有員工且被選中
      }

      return '#iconyuangongguanli2'; // 有員工但未選中
    },
    // getDynamicIconHref(data, field, baseIcon, emptyIcon, defaultIcon) {
    //   const hasValue = !!data[field];
    //   const currentKey = this.$refs.tree.getCurrentKey();
    //   const isSelected = currentKey === data.departmentID;

    //   if (!hasValue) {
    //     return emptyIcon;
    //   }

    //   return isSelected ? baseIcon : defaultIcon;
    // },
    staffClick(node,data){
      // 跳转员工tab
      this.$emit('update:currentSelected', 2);
      this.$emit('update:isExpanded', false);

    },
    depClick(node,data){
      // 跳转组别tab
      this.$emit('update:currentSelected', 1);
      this.$emit('update:isExpanded', false);
    },
    toggleAsideWidth(){
      this.$emit('update:isExpanded', !this.isExpanded);
      this.changeScrollLeft()
    },
    changeScrollLeft(){
      if(this.isExpanded){
        this.$nextTick(() => {
          const el = this.$refs.treeList;
          if (el) {
            el.scrollTo({ left: 0, behavior: 'smooth' });
          }
        });
      }
    },
    search() {
      this.$refs.tree.filter(this.departmentName);
    },
    setTreeCurrentNode(departmentId) {
      this.$nextTick(() => {
        // 使用 el-tree 的 setCurrentKey 方法选中节点
        this.$refs.tree.setCurrentKey(departmentId);
      });
    },
    setActive(num) {
      this.isActive = num;
    },
    nodeClick(data, node, vnode) {
      this.$emit('update:isExpanded', false);
      this.$emit("choose", data);
    },
    filterNode(value, data) {
      if (!value) {return true;}
      return data.departmentName.toLocaleLowerCase().indexOf(value.replace(/\s/g,'').toLocaleLowerCase()) !== -1;
    }
  },
  computed: {
    ...mapState(["userInfo"])
  },
  watch: {
    asideHeight(val) {
      this.$nextTick(() => {
        if (!val) {return;}
        this.treeHeight =
          val - document.getElementById("search-box").offsetHeight - 55 + "px";
          // val - document.body.clientHeight - 55 + "px";
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/element-reset.less";

/deep/ .filter-tree {
     height: calc(100% - 40px);
     width: 100%;
     .el-scrollbar__wrap {
         overflow-x: auto;
         .el-scrollbar__view {
             white-space: nowrap;
             display: inline-block;
             min-width: 100%;
         }
     }
 }
.aside-container {
  position: relative;
  .expanfold-icon{
    height:32px;
    background-color: #666B74;
    cursor: pointer;
    position: absolute;
    top: 50%;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    padding-top: 10px;
    i{
      font-size: 15px;
      color: #fff;
    }
  }
  .left_95{
    left:95%;
  }
  .left_98{
    left:98%
  }
  .aside-tree-link {
    margin-left: 3px;
    padding-left: 8px;
    max-width: 60px;
    color: black;
    cursor: pointer;
    text-decoration: underline;
    display: inline-block;
    background-color: #ffffff;
  }
  .aside-link{
    margin-left: 0px;
    padding-left: 11px;

  }
  .orange{
    color: orange;
  }
  .gray{
    color: gray;
  }
  box-sizing: border-box;
  width: 100%;
  min-width: 340px;
  background-color: #fff;
  min-height: 300px;
  height: 100%;
  padding: 18px 20px;

  .search-box {
    display: flex;
    align-items: center;
    .el-input {
      flex: 1; /* 自动占满剩余空间 */
      min-width: 160px;
      // width: 160px;
      /deep/.el-input__inner {
        height: 38px;
        background: #fafafb;
        border-radius: 10px;
        border: none;
      }
    }
    .el-button {
      width: 60px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #0062ff;
      color: #0062ff;
      border-radius: 10px;
      padding: 0;
      margin-left: 10px;
      flex-shrink: 0; /* 按钮不缩 */
      margin-left: 8px;
    }
    .exdbut{
      color: #fff;
      background-color: #0062ff;
    }
  }
  .btn-classify {
    height: 32px;
    padding: 0 3px;
    border: 1px solid #f1f1f5;
    border-radius: 20px;
    margin-top: 15px;
    line-height: 32px;
    span {
      width: 110px;
      height: 28px;
      display: inline-block;
      border-radius: 8px;
      text-align: center;
      line-height: 28px;
      &.active {
        background-color: #0062ff;
        color: #fff;
      }
    }
  }
  .tree-list {
    font-size: 14px;
    margin-top: 15px;
    // 文字可换行
    // width:220px;
    // ::v-deep .el-tree-node {
    //   white-space: normal;
    //   .el-tree-node__content {
    //     height: 100%;
    //     align-items: start;
    //   }
    // }

    .el-tree {

      /deep/ .el-tree-node>.el-tree-node__children{
        overflow:visible;
      }
      /deep/.is-current > .el-tree-node__content {
        // .el-tree-node__label {
        //   background-color: @theme-color;
        //   color: #fff;
        //   padding: 0 5px;
        // }
        .custom-tree-node {
          background-color: @theme-color;
          color: #fff;
          padding-left:5px ;
        }
      }
    }
  }
  /* .text-cut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  } */
}
</style>